import { Loading } from '@components/loadling';
import { initSdk, onApiError } from '@proccess/api';
import { PayloadAction } from '@reduxjs/toolkit';
import { actions } from '@store/reducer';
import { AxiosResponse } from 'axios';
import Router from 'next/router';
import { all, call, fork, put, takeEvery, takeLatest } from 'redux-saga/effects';

function* requestFAQs({
  payload: { page = 0, limit = 20 },
}: PayloadAction<{ page?: number; limit?: number }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.get('/admin/faqs', {
        params: {
          page,
          limit,
        },
      })
    );

    yield put(actions.saveFAQs({ data: { ...response.data, limit } }));
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherRequestfaq() {
  yield takeEvery(actions.requestFAQs, requestFAQs);
}

function* deleteFAQs({ payload: { data } }: PayloadAction<{ data: any }>) {
  try {
    Loading.Show();
    const response: AxiosResponse = yield call(() =>
      initSdk.patch(`/admin/faqs/${data.get('id')}`, data, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
    );

    if (response.data) {
      Router.back();
    }
  } catch (error) {
    onApiError(error);
  } finally {
    Loading.Hide();
  }
}

function* watcherDeleteFAQs() {
  yield takeLatest(actions.deleteFAQs, deleteFAQs);
}

const faqSagas = function* root() {
  yield all([fork(watcherRequestfaq), fork(watcherDeleteFAQs)]);
};
export { faqSagas };
